import GetAllRecords from './GetAllRecords';
import InviteNewAdvertiser from './InviteNewAdvertiser';
import CampaignStepsMangment from './CreateNewCampaign';
import CampaignRecords from './CampaignRecords';
import Roles from './Roles';
import GetAdvertisersDisplays from './GetAdvertisersDisplays';
import GetCampaignBudgetCost from './GetCampaignBudgetCost';
import CalculateCampaignPrice from './CalculateCampaignPrice';
import CreateFavourite from './CreateFavourite';
import GetAllFavourites from './GetAllFavourites';
import DeleteFavourite from './DeleteFavourite';
import GetAllFavouritesLookup from './GetAllFavouritesLookup';
import CampaignDisplays from './CampaignDisplays';
import CostBreakdownEmail from './CostBreakdownEmail';
import ProgressStepAdv from './ProgressAdv';
import ProofofPlay from './ProofofPlay';
const Advertisers = {
  getAllAdvertisers: GetAllRecords,
  InviteNewAdvertiser: InviteNewAdvertiser,
  CampaignStepsMangment: CampaignStepsMangment,
  Roles,
  CampaignRecords: CampaignRecords,
  GetAdvertisersDisplays: GetAdvertisersDisplays,
  GetCampaignBudgetCost: GetCampaignBudgetCost,
  CalculateCampaignPrice: CalculateCampaignPrice,
  CreateFavourite: CreateFavourite,
  GetAllFavourites: GetAllFavourites,
  DeleteFavourite: DeleteFavourite,
  GetAllFavouritesLookup: GetAllFavouritesLookup,
  CampaignDisplays: CampaignDisplays,
  CostBreakdownEmail: CostBreakdownEmail,
  ProgressStepAdv: ProgressStepAdv,
  ProofofPlay: ProofofPlay,
};

export default Advertisers;
